module.exports = __webpack_public_path__ + "img/png3.466bd7e3.png";